/**
 * Список абонементов: аккордеон карточек и диалог выбора количества сеансов.
 * Диалог — нативный <dialog>, поэтому ловушка фокуса, закрытие по Esc
 * и инертный фон достаются от браузера.
 */

const ARIA_EXPANDED = 'aria-expanded';
const ARIA_CONTROLS = 'aria-controls';
const EXPANDED_VALUE = 'true';
const COLLAPSED_VALUE = 'false';

class SubscriptionPlans extends HTMLElement {
  connectedCallback() {
    this.toggles = Array.from(this.querySelectorAll('[data-subscription-toggle]'));

    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlockSelect = this.handleBlockSelect.bind(this);

    this.addEventListener('click', this.handleClick);
    this.addEventListener('change', this.handleChange);
    this.addEventListener('shopify:block:select', this.handleBlockSelect);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('change', this.handleChange);
    this.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  handleClick(event) {
    const toggle = event.target.closest('[data-subscription-toggle]');
    if (toggle) {
      this.toggleItem(toggle);
      return;
    }

    const buyLink = event.target.closest('[data-subscription-buy]');
    if (buyLink) {
      this.openDialog(buyLink, event);
      return;
    }

    const closeButton = event.target.closest('[data-subscription-dialog-close]');
    if (closeButton) {
      const dialog = closeButton.closest('[data-subscription-dialog]');
      if (dialog) dialog.close();
      return;
    }

    // Клик мимо содержимого диалога приходит на сам <dialog> — это подложка
    if (event.target.matches('[data-subscription-dialog]')) {
      event.target.close();
    }
  }

  handleChange(event) {
    const input = event.target.closest('.subscription-plans__option-input');
    if (!input || !input.dataset.price) return;

    const dialog = input.closest('[data-subscription-dialog]');
    const priceOutput = dialog ? dialog.querySelector('[data-subscription-price]') : null;
    if (priceOutput) window.sbAnimateMoney(priceOutput, input.dataset.price);
  }

  /** В редакторе темы выбор блока должен раскрывать соответствующую карточку. */
  handleBlockSelect(event) {
    const toggle = event.target.querySelector('[data-subscription-toggle]');
    if (toggle) this.expandOnly(toggle);
  }

  toggleItem(toggle) {
    const isExpanded = toggle.getAttribute(ARIA_EXPANDED) === EXPANDED_VALUE;

    if (isExpanded) {
      this.setExpanded(toggle, false);
      return;
    }

    this.expandOnly(toggle);
  }

  /** Открытым остаётся один абонемент: так список не разъезжается по высоте. */
  expandOnly(toggle) {
    this.toggles.forEach((item) => this.setExpanded(item, item === toggle));
  }

  setExpanded(toggle, expanded) {
    toggle.setAttribute(ARIA_EXPANDED, expanded ? EXPANDED_VALUE : COLLAPSED_VALUE);

    const panel = document.getElementById(toggle.getAttribute(ARIA_CONTROLS));
    if (panel) panel.hidden = !expanded;
  }

  openDialog(buyLink, event) {
    const dialog = document.getElementById(buyLink.getAttribute(ARIA_CONTROLS));

    // Без поддержки <dialog> ссылка отрабатывает штатно и ведёт на карточку товара
    if (!dialog || typeof dialog.showModal !== 'function') return;

    event.preventDefault();
    dialog.showModal();
  }
}

customElements.define('subscription-plans', SubscriptionPlans);
